import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';

import reportError from 'ha/helpers/bugsnag/reportError';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';

import { getSupportedCurrenciesFetchStatus } from '../selectors';

export enum ActionTypes {
  START = '[supportedCurrencies] LOAD_SUPPORTED_CURRENCIES',
  DONE = '[supportedCurrencies] LOAD_SUPPORTED_CURRENCIES_DONE',
  FAIL = '[supportedCurrencies] LOAD_SUPPORTED_CURRENCIES_FAIL',
}

export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (currencies: string[]) => createAction(ActionTypes.DONE, currencies),
  fail: () => createAction(ActionTypes.FAIL),
};
export type ActionsUnionType = ActionsUnion<typeof Actions>;

const fetchSupportedCurrencies =
  (): Thunk =>
  (dispatch, getState, { apiV2 }) => {
    const state = getState();

    if (!getIsAuthenticated(state)) {
      return Promise.resolve();
    }

    if (getSupportedCurrenciesFetchStatus(state) === 'success') {
      return Promise.resolve();
    }

    dispatch(Actions.start());

    return apiV2
      .getSupportedCurrencies()
      .then(({ data }) => {
        dispatch(Actions.done(data.transactionCurrencies));
      })
      .catch(error => {
        reportError('Error getting the supported currencies', {
          metaData: { error },
        });
        dispatch(Actions.fail());
      });
  };

export default fetchSupportedCurrencies;
